<template>
  <div class="index_wrapper">
    <page-top active="1" :page="index" name="index" height="516px"></page-top>
    <div class="keynews animate__animated animate__fadeInUp">
      <div class="news">
        <p>
          <img class="icon" src="../assets/img/index/b1.png" />国家高新技术企业
        </p>
        <i></i>
        <p>
          <img
            class="icon"
            src="../assets/img/index/b2.png"
          />商务部全国十大创新案例
        </p>
      </div>
    </div>
    <div class="index index1 animate__animated animate__fadeInUp">
      <ul class="i_top">
        <li @click="openUrl(1)" class="hand">
          <span>前沿技术在产融数字化中的深度应用（一）</span>
          <p>
            三悦科技作为产业数字金融科技服务企业，同时具备产业数字化和数字金融的科技服务能力，通过数字技术链接产业和金融这两端，让产业端和金融端发挥协同创新作用，形成“科技-产业-金融”的生态循....
          </p>
        </li>
        <li @click="openUrl(2)" class="hand">
          <span>前沿技术在产融数字化中的深度应用（二）</span>
          <p>
            三悦科技在实践过程中形成了场景结合技术助力银行金融业务发展的思想，逐步形成了交易撮合平台以及数据链金融理论，以前沿技术为核心，构建产业数字金融的产融场景，最终形成市场产品的重要能力....
          </p>
        </li>
      </ul>
      <div class="i_title">
        <b></b>
        <p>三悦科技</p>
      </div>
      <div class="i_bottom mr_1200">
        <h4>数字科技:专注于产业数字化与产融综合解决方案</h4>
        <p>
          三悦科技成立于2015年，是一家专注于产业数字化与产融综合解决方案的数字科技平台公司。<br />
          在数字供应链金融业务领域市场名列前茅，通过银链通平台为产业端提供数字化核心系统解决方案，包括为产业链上下游构建供销交易撮合、仓储科技监管、场景验真确权、数字供应链管理、数字供应链金融等全链路服务；为金融机构提供科技监管、场景解构、可信数据模型、资产合规管理等产品和服务。
        </p>
        <div class="btn hand" @click="toMore">了解更多</div>
      </div>
    </div>
    <!-- 业务定位 -->
    <div class="index2 animate__animated animate__fadeInUp">
      <div class="i2_title">
        <p>业务定位</p>
        <p>产业数字化+科技监管+产融解决方案</p>
      </div>
      <div class="ab">
        <a href="">
          <img src="../assets/img/index/y1.png" />
          <p>解决产业融资需求</p>
        </a>
        <a href="">
          <img src="../assets/img/index/y2.png" />
          <p>穿透底层资产形成交易信用</p>
        </a>
      </div>
      <div class="process mr_1200">
        <ul class="p_ul flex">
          <li>
            <p>核心企业</p>
            <p>产业链上中小微企业</p>
            <p>产业平台</p>
          </li>
          <li>
            <p class="fs_18">三悦科技</p>
            <p>数字科技(平台底座)+场景解构</p>
          </li>
          <li>
            <p class="fs_18">金融机构</p>
          </li>
        </ul>
        <div class="p_cont flex">
          <p class="p_img">
            <img src="../assets/img/index/y3.png" alt="" />
          </p>
          <div class="flex p_cont_r">
            <p class="flex imgs">
              <img class="mrt_21" src="../assets/img/index/y6.png" alt="" />
              <b>
                产业数字化平台<br />
                + <br />数字供应链金融
              </b>
            </p>
            <ul class="flex p_ls">
              <li>
                <img src="../assets/img/index/y9.png" alt="" />
                <p>数字支付</p>
              </li>
              <li>
                <img src="../assets/img/index/y10.png" alt="" />
                <p>场景信贷融资</p>
              </li>
              <li>
                <img src="../assets/img/index/y11.png" alt="" />
                <p>订单融资</p>
              </li>
              <li>
                <img src="../assets/img/index/y12.png" alt="" />
                <p>数字债项融资</p>
              </li>
            </ul>
          </div>
          <p class="p_img">
            <img src="../assets/img/index/y4.png" alt="" />
          </p>

          <div class="flex p_cont_r">
            <p class="flex imgs mrt_11">
              <b> 数字金融科技 </b>
              <img src="../assets/img/index/y7.png" alt="" />
            </p>
            <ul class="flex p_ls">
              <li>
                <img src="../assets/img/index/y13.png" alt="" />
                <p>风险解构</p>
              </li>
              <li>
                <img src="../assets/img/index/y14.png" alt="" />
                <p>场景验真</p>
              </li>
              <li>
                <img src="../assets/img/index/y15.png" alt="" />
                <p>交易信用</p>
              </li>
              <li>
                <img src="../assets/img/index/y16.png" alt="" />
                <p>资产管理</p>
              </li>
            </ul>
          </div>
          <p class="p_img">
            <img src="../assets/img/index/y5.png" alt="" />
          </p>
        </div>
      </div>
      <div class="cuboid mr_1200">
        <div class="up">
          <img
            v-for="item in 3"
            :key="item.id"
            src="../assets/img/index/y8.png"
            alt=""
          />
        </div>
        <div class="c_first">
          <h4>场景解构</h4>
          <p>交易场景验真</p>
          <i>+</i>
          <p>资产科技监管</p>
          <i>+</i>
          <p>资金闭环管理</p>
        </div>
        <div class="c_first c_second">
          <h4>底层科技</h4>
          <p>区块链</p>
          <i>+</i>
          <p>物联网</p>
          <i>+</i>
          <p>大数据</p>
          <i>+</i>
          <p>人工智能</p>
        </div>
      </div>
    </div>
    <!-- 赋能客户 -->
    <div class="index3 animate__animated animate__fadeInUp">
      <img src="/static/images/newaward.jpg" alt="" />
      <div>
        <h2><b>专业权威</b>的奖项及认证</h2>
        <p>
          累计荣获<b>170+</b>行业奖项及社会认可<i></i>行业类<b>30+</b
          ><i></i>金融科技类<b>40+</b><i></i>权威认证类<b>30+</b
          ><i></i>软件著作权<b>60<span>项</span></b
          ><i></i>前沿技术专利<b>11<span>项</span></b>
        </p>
      </div>
    </div>
    <page-bottom></page-bottom>
  </div>
</template>

<script>
export default {
  mame: "Index",
  data() {
    return {
      index: 1,
    };
  },
  methods: {
    toMore() {
      this.$router.push("/about");
      window.scrollTo(0, 0);
    },
    openUrl(val) {
      let url =
        val == 1
          ? "https://mp.weixin.qq.com/s/lG5nIqi24Yu9TkOIUbo_sQ"
          : val == 2
          ? "https://mp.weixin.qq.com/s/ndkw1VQZ1E2ZkhfSWocwrQ"
          : "";
      window.open(url);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.fs_18 {
  font-size: 18px;
}
.index_wrapper {
  width: 100%;
  height: 100%;
}

.keynews {
  position: relative;
  top: -90px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 201;
  border-top: 1px solid #fff;

  .news {
    display: flex;
    justify-content: center;
    align-items: center;
    p {
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
      letter-spacing: 0.24px;
      line-height: 32px;
      text-decoration: none;
      cursor: default;

      .icon {
        display: inline-block;
        margin-right: 10px;
        vertical-align: middle;
        height: 32px;
      }
    }

    i {
      display: inline-block;
      width: 1px;
      height: 44px;
      background-color: #fff;
      margin: 0 60px;
    }
  }
}

.flex {
  display: flex;
}

.index {
  height: calc(100% - 80px);
  width: 100%;
  height: 100%;
}

.index1 {
  background: url("../assets/img/index/bg1.png") no-repeat;
  background-size: 100% 100%;
  height: 782px;
  margin-top: -100px;
  .i_top {
    margin: 0 80px 80px;
    background: #fff;
    box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.1);
    padding: 10px 60px;
    height: 104px;
    display: flex;
    justify-content: space-between;

    li {
      display: inline-block;
      width: 48%;
      height: 84px;

      span {
        display: inline-block;
        transition: all 0.3s;
        width: 100%;
        color: #333333;
        font-weight: 400;
        font-size: 16px;
        margin-top: 10px;
        margin-bottom: 10px;
      }

      p {
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        max-width: 100%;
        font-size: 14px;
        color: #333;
        text-align: justify;
        line-height: 1.5;
        font-weight: 300;
      }
    }
  }

  .i_title {
    b {
      display: block;
      margin: 0 auto;
      background: url("../assets/img/index/sanyue.png") no-repeat;
      width: 206px;
      height: 30px;
    }

    p {
      margin-top: -25px;
      font-weight: 400;
      font-size: 32px;
      color: #000000;
    }
  }

  .i_bottom {
    width: 970px;
    margin-top: 72px;
    height: 292px;
    background: #fff;
    box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.1);
    text-align: left;
    padding: 60px 130px 0 130px;

    h4 {
      padding-bottom: 20px;
      font-weight: 400;
      font-size: 20px;
      color: #000000;
    }

    p {
      width: 980px;
      line-height: 30px;
      font-weight: 300;
      font-size: 16px;
      color: #333333;
    }

    .btn {
      float: right;
      margin-top: 25px;
      width: 136px;
      height: 42px;
      background: #003c84;
      border-radius: 8px 8px 8px 8px;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      line-height: 42px;
      text-align: center;
    }
  }
}

.index2 {
  background: #ffffff;
  padding-top: 157px;
  padding-bottom: 134px;

  .i2_title {
    p {
      font-weight: 400;
      color: #000000;
    }

    p:nth-child(1) {
      font-size: 32px;
    }

    p:nth-child(2) {
      margin-top: 10px;
      font-size: 24px;
    }
  }

  .ab {
    margin-top: 94px;
    display: flex;
    justify-content: start;
    width: 1150px;
    margin: 94px auto 0;

    a {
      display: block;
      position: relative;

      img {
        width: 291px;
        height: 44px;
      }

      p {
        position: absolute;
        top: 10px;
        left: 55px;
        font-weight: 500;
        font-size: 16px;
        color: #003c84;
      }
    }
  }

  .process {
    margin-top: 26px;
    margin-bottom: 50px;
    height: 340px;
    background: url("../assets/img/index/bg2.png") no-repeat;
    background-size: 100% 100%;

    .p_ul {
      padding-top: 50px;
      justify-content: space-around;

      li {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 211px;
        height: 61px;
        background: #003c84;

        p {
          font-weight: 400;
          font-size: 13px;
          color: #ffffff;
        }
      }
    }

    .p_cont {
      width: 1000px;
      margin: 50px auto 0;
      justify-content: space-evenly;

      .p_img {
        width: 142px;
        height: 142px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .p_cont_r {
        align-items: center;
        flex-direction: column;
        justify-content: space-between;
      }

      .imgs {
        img {
          width: 28px;
          height: 26px;
        }

        b {
          font-weight: 400;
          font-size: 16px;
          color: #003c84;
          width: 130px;
        }
      }

      .p_ls {
        flex-wrap: wrap;
        width: 205px;

        li {
          display: flex;
          align-items: center;

          img {
            width: 32px;
            height: 32px;
            padding-top: 5px;
          }

          p {
            font-weight: 400;
            font-size: 14px;
            color: #333333;
          }
        }
      }
    }
  }

  .cuboid {
    height: 147px;
    background: url("../assets/img/index/bg3.png") no-repeat;
    background-size: 100% 100%;
    position: relative;

    .up {
      display: flex;
      justify-content: space-around;
      img {
        width: 24px;
        height: 26px;
      }
    }

    .c_first {
      display: flex;
      position: absolute;
      top: 56px;
      left: 42px;

      h4 {
        font-weight: 400;
        font-size: 18px;
        color: #003c84;
        margin-right: 40px;
        margin-top: 6px;
      }

      i {
        display: block;
        margin: 0 20px;
        font-weight: 400;
        font-size: 22px;
        color: #003c84;
      }

      p {
        background: #fff;
        padding: 7px 105px;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
      }
    }

    .c_second {
      top: 106px;

      p {
        padding: 7px 88px;
      }

      i {
        margin: 0 10px;
      }
    }
  }
}

.index3 {
  width: 100%;
  height: 980px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
  }

  div {
    position: absolute;
    top: 25px;
    margin: 0 auto;
    width: 100%;

    h2 {
      font-weight: 400;
      font-size: 32px;
      color: #000000;
      margin-bottom: 28px;

      b {
        color: #dab866;
        font-weight: 400;
      }
    }

    p {
      font-weight: 400;
      font-size: 16px;
      color: #000000;

      b {
        font-weight: bold;
        font-size: 32px;
        color: #dab866;

        span {
          color: #dab866;
          font-size: 16px;
        }
      }

      i {
        margin-right: 13px;
      }
    }
  }
}
.mrt_21 {
  margin-top: 21px;
}
.mrt_11 {
  margin-top: 11px;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue